import { alpha, Grid, styled, Typography } from '@mui/material';

export const TwoArrowGrid = styled(Grid)(({ theme: _theme }) => ({
    width: '32px',
    height: '32px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    borderRadius: '8px',
    padding: '0 2px',
}));

export const NameCompanyText = styled(Typography)(({ theme }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.primary.contrastText,
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
}));

export const CompanyHeaderText = styled(Typography)(({ theme }) => ({
    color: alpha(theme.custom.c18, 0.4),
    fontSize: '0.625rem',
    fontWeight: 700,
    textTransform: 'uppercase',
}));

export const MainContainer = styled(Grid)(({ theme: _theme }) => ({
    gap: '16px',
    alignItems: 'center',
    padding: '6px 8px 6px 2px',
    flexWrap: 'nowrap',
    cursor: 'pointer',
    borderRadius: '8px',
    minHeight: '48px',
}));
